/* unplugin-vue-components disabled */import { render } from "./fpkj.vue?vue&type=template&id=0365d310"
import script from "./fpkj.vue?vue&type=script&lang=js"
export * from "./fpkj.vue?vue&type=script&lang=js"

import "./fpkj.vue?vue&type=style&index=0&id=0365d310&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/disney-mobile-ui-production-environment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__